export default {
  name: 'Parking Area',
  id: 'ParkingArea',
  data: [
    {
      title:
        'Inclement weather is approaching.',
      icon1: '/static/svgs/commercial/parking-area.svg',
      answers: [
        'Turn off all utilities at the main switches or valves when instructed to do so. (Gas and electric shutoff) Board up windows prior to forecasted high wind storm events, such as hurricanes.'
      ],
      correctAnswerIndex: 0,
      position: {
        x: 0.54,
        y: 1.19,
        z: 0.8
      },
      completed: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/commercial/firstFloor/ParkingArea.js